/** @jsxImportSource @emotion/react */
import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import style from './deleteBasketItemModal.style'

interface DeleteBasketItemModalProps {
  onDelete: () => void;
  onCancel: () => void;
  open: boolean;
}

export const DeleteBasketItemModal = ({
  onDelete,
  onCancel,
  open,
}: DeleteBasketItemModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal css={style.modalContainer} size='mini' open={open}>
      <Modal.Content css={style.modalContent}>
        <Modal.Description>
          <p>{t('salesAssistant.productsBasket.delete.warningMessage')}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions css={style.modalActions}>
        <Button css={style.cancelBtn} content={t('salesAssistant.productsBasket.delete.no')} onClick={onCancel} />
        <Button
          css={style.confirmDeleteBtn}
          content={t('salesAssistant.productsBasket.delete.yes')}
          onClick={onDelete}
        />
      </Modal.Actions>
    </Modal>
  );
};